import SignInAsButton from "./SignInAsButton"

export default SignInAsButton
